import { Badge } from '@/components/ui/badge'

interface UserRoleBadgeProps {
  isSuperUser: boolean
  className?: string
}

export const UserRoleBadge = ({ isSuperUser, className }: UserRoleBadgeProps) => {
  if (!isSuperUser) {
    return (
      <Badge variant="outline" className={`bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-100 ${className || ''}`}>
        End User
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className={`bg-red-100 text-red-800 border-red-300 hover:bg-red-100 ${className || ''}`}>
      Super User
    </Badge>
  )
}
